import { RequestService } from "../../../../common/services/RequestService";
import { GET_DOCUMENTS_LIST } from "./constants";

export const getDocumentsListRequest = async orderId => {
  const response = await RequestService.get(
    GET_DOCUMENTS_LIST.replace("{order_id}", orderId)
  );
  return response;
};
